// Utils
import { sortChanges } from './applyChanges/sortChanges';
import { removeValuesRecursive } from './removeValuesRecursive/removeValuesRecursive';
/**
 * Remove references to deleted objects from changes, such that we remove any change directly on the
 * deleted objector we remove the deleted object from the change. e.g. Remove from array changes.
 *
 * @param {ChangeList} leftChanges
 * @param {ChangeList} rightChanges
 *
 * @return {ChangeList}
 */
export var removeDeletedObjectsFromChanges = function (leftChanges, rightChanges) {
    var leftChangesFiltered = {};
    var objectRemovals = sortChanges(rightChanges).objectRemovals;
    var objectIdsToRemove = Object.keys(objectRemovals);
    Object.keys(leftChanges)
        .forEach(function (item) {
        if (objectRemovals[item] !== undefined) {
            return;
        }
        var _a = leftChanges[item], oldValue = _a[0], newValue = _a[1];
        oldValue = removeValuesRecursive(oldValue, objectIdsToRemove);
        newValue = removeValuesRecursive(newValue, objectIdsToRemove);
        leftChangesFiltered[item] = [oldValue, newValue];
    });
    return leftChangesFiltered;
};
//# sourceMappingURL=removeDeletedObjectsFromChanges.js.map